export default __webpack_public_path__ + "static/A01-312f4ba7db01ff885a9a7c14d226941a.jpg";